// helpers/categoryLink.js
export function getCategoryLink(category) {
    const customLinks = {
      'Shipment Costs': '/shipment-calculator',
      'Business Loans': '/business-loan',
      'Channel financing': '/enterprise/channel-financing-india',
      'Early Payments':'/enterprise/early-payment-discount',
      'Export Financing':'/export-factoring',
      'Hsn Code':'/hsn-code',
      'Invoice discounting':'/export-factoring/invoice-discounting-platform',
      'Vendor financing':'/enterprise/vendor-financing-india',
      'HTS Code':'/hts-code',
      'Import Factoring':'/import-factoring',
      'Purchase order financing':'/export-factoring/purchase-order-financing',

      // Add more custom mappings as needed
    };
  
    return customLinks[category.name] || `/blogs/category/${category.id}/${category.slug}`;
  }
  